import React from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  Typography,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@mui/material";
import { ToggleDrawerContext } from "../../contexts/ToggleDrawer";
import { FaCirclePlus } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { Close } from "@mui/icons-material";
import usePrimaryColor from "../../hooks/usePrimaryColor";

const avatarSize = 70;

export default function EntityDialog({ children, closeText, title, testId }) {
  const [isOpen, setIsOpen] = React.useContext(ToggleDrawerContext);
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const color = usePrimaryColor();

  const toggleDialog = (open) => (event) => {
    setIsOpen(open);
  };

  return (
    <React.Fragment>
      <Card
        sx={{
          width: 125,
          borderRadius: 2,
          boxShadow: 3,
          bgcolor: color,
          maxHeight: "155px",
          position: "relative",
          border: `2px solid ${color}`,
          transition: "0.3s",
          "&:hover": {
            cursor: "pointer",
            boxShadow: 6,
            transform: "scale(1.05)",
            borderColor: color,
            "& .card-actions": { display: "flex" },
          },
        }}
        onClick={toggleDialog(true)}
        data-testid={testId && `${testId}.trigger`}
      >
        <Box display="flex" justifyContent="center" alignItems="center" pt={2}>
          <Avatar
            sx={{
              width: avatarSize,
              height: avatarSize,
              color: "white",
              bgcolor: "transparent",
            }}
          >
            <FaCirclePlus size={75} />
          </Avatar>
        </Box>

        <CardContent sx={{ textAlign: "center" }}>
          <Typography
            fontWeight="bold"
            color="white"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {String(t(title)).toUpperCase()}
          </Typography>
        </CardContent>
      </Card>

      <Dialog
        open={isOpen}
        onClose={toggleDialog(false)}
        maxWidth="lg"
        fullWidth
        fullScreen={isSmallScreen}
        data-testid={testId && `${testId}.dialog`}
      >
        <DialogContent>
          <Box sx={{ width: "auto", padding: 1 }}>
            <Box
              display={"flex"}
              justifyContent={"end"}
              alignItems={"center"}
              mb={2}
            >
              <IconButton color="error" onClick={toggleDialog(false)} title={t("Close")}>
                <Close />
              </IconButton>
            </Box>
            {children}
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
